/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MountContainerEntry } from '../../models/mount-container-entry';
import { MountContainerResponse } from '../../models/mount-container-response';

export interface MountContainer$Params {
  workCenterId: number;
      body: MountContainerEntry
}

export function mountContainer(http: HttpClient, rootUrl: string, params: MountContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<MountContainerResponse>> {
  const rb = new RequestBuilder(rootUrl, mountContainer.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MountContainerResponse>;
    })
  );
}

mountContainer.PATH = '/api/v1/Material/{workCenterId}/Mount';
